import { render, staticRenderFns } from "./NotificationsEditor.vue?vue&type=template&id=5c93b630&scoped=true&"
import script from "./NotificationsEditor.vue?vue&type=script&lang=js&"
export * from "./NotificationsEditor.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsEditor.vue?vue&type=style&index=0&id=5c93b630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93b630",
  null
  
)

export default component.exports